import { useNavigate } from "react-router-dom";
import { useFplId } from "../context/FplIdContext";

export default function AddTeamChip() {
  const { fplId, manager } = useFplId();
  const navigate = useNavigate();

  if (fplId) {
    return (
      <button
        onClick={() => navigate("/my-team")}
        className="fpl-add-team is-connected"
        title="My team"
      >
        <span className="fpl-add-team-avatar">
          {(manager?.team_name || "MY").slice(0, 2).toUpperCase()}
        </span>
        <span className="fpl-add-team-copy">
          <strong>{manager?.team_name || "My Team"}</strong>
          <small>View team</small>
        </span>
      </button>
    );
  }

  return (
    <button
      onClick={() => navigate("/onboarding")}
      className="fpl-add-team"
      title="Add a team"
    >
      <span className="fpl-add-plus">+</span>
      <span>Add a Team</span>
    </button>
  );
}
